import "./AlertDialogRuleListComponent.scss";
import {IComponentOptions, IFormController, IOnDestroy, IOnInit} from "angular";
import {AlertDialogStore} from "../store/AlertDialogStore";
import {Observable, ReplaySubject} from "rxjs";
import {AlertDialogRule} from "../models/AlertDialogRule";
import {ObjectUtil} from "../../../../js/util/ObjectUtil";
import {TradingAlertRuleType} from "../../../models/rules/TradingAlertRuleType";
import {UnderlyingStatistics} from "../../../models/UnderlyingStatistics";
import {RuleComponent} from "../rules/RuleComponent";

export const RuleList = "tfAlertRuleList";

export function ruleList(parentDir: string): IComponentOptions {
    return {
        templateUrl: `${parentDir}/rule-list/AlertDialogRuleListComponent.html`,
        bindings: {
            store: "<"
        },
        controllerAs: "ctrl",
        controller: AlertDialogRuleListComponentController
    };
}

export class AlertDialogRuleListComponentController implements IOnInit, IOnDestroy {

    public readonly store: AlertDialogStore;
    public rulesForm: IFormController;
    public ruleTypes = Object.keys(TradingAlertRuleType);

    public statistics$: Observable<UnderlyingStatistics>;
    public rules$: Observable<ReadonlyArray<AlertDialogRule>>;
    public ruleComponents: Array<RuleComponent> = [];

    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor() {

    }

    public $onInit(): void {
        this.rules$ = this.store
                          .rules
                          .takeUntil(this.destroyed$);
        this.statistics$ = this.store
                               .statistics
                               .takeUntil(this.destroyed$);
    }

    public addChildRuleComponent(ruleComponent: RuleComponent) {
        this.ruleComponents.push(ruleComponent);
    }

    public removeChildRuleComponent(ruleComponent: RuleComponent) {
        this.ruleComponents = this.ruleComponents.filter(r => r !== ruleComponent);
    }

    public addRule() {
        this.store.addRule();
    }

    public changeRuleType(rule: AlertDialogRule, type: TradingAlertRuleType) {
        const copy = ObjectUtil.copy(rule);
        Object.assign(copy, { type });
        this.store.replaceRule(copy);
    }

    public updateRule(rule: AlertDialogRule) {
        this.store.replaceRule(rule);
        this.validate();
    }

    public removeRule(rule: AlertDialogRule) {
        this.store.removeRule(rule.uiid);
        this.validate();
    }

    public $onDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }

    public validate() {
        const hasRules = this.ruleComponents.length > 0;
        this.rulesForm.$setValidity("has-rules", hasRules, this.rulesForm);

        const wouldTriggerImmediately = this.ruleComponents
                                            .every(r => r.wouldTriggerImmediately);
        if (wouldTriggerImmediately) {
            this.rulesForm.$setValidity("trigger-immediately", false, this.rulesForm);
        } else {
            this.rulesForm.$setValidity("trigger-immediately", true, this.rulesForm);
        }
    }
}
